import { ConfigType } from "@stitches/react/types/config";

const theme: ConfigType.Theme = {
  colors: {
    primary: "hsl(0, 0%, 100%)",
    secondary: "hsl(0, 0%, 0%)",
    accent100: "hsl(0, 0%, 95%)",
    accent200: "hsl(0, 0%, 90%)",
    accent300: "hsl(0, 0%, 52%)",
  },
  space: {
    0: 0,
    1: "5px",
    2: "10px",
    3: "15px",
    4: "20px",
    5: "25px",
    6: "35px",
    7: "45px",
    8: "65px",
    9: "80px",
  },
  fontSizes: {
    1: "10px",
    2: "14px",
    3: "18px",
    4: "20px",
    5: "24px",
    6: "28px",
  },
  fonts: {
    body: "Nunito Sans, sans-serif",
  },
  fontWeights: {
    default: 300,
    semiBold: 600,
    bold: 800,
  },
  lineHeights: {
    normal: 1,
    wide: 1.25,
    wider: 1.5,
  },
  sizes: {
    0: 0,
    1: "5px",
    2: "10px",
    3: "15px",
    4: "20px",
    5: "25px",
    6: "35px",
    7: "45px",
    8: "65px",
    9: "80px",
  },
  radii: {
    0: 0,
    1: "3px",
    2: "5px",
    3: "10px",
  },
  shadows: {
    0: "none",
    1: "0 0 0 hsl(0, 0%, 95%), 0 2px 4px hsl(0, 0%, 80%)",
    2: "0 0 0 hsl(0, 0%, 95%), 0 4px 8px hsl(0, 0%, 80%)",
    3: "0 0 0 hsl(0, 0%, 95%), 0 8px 16px hsl(0, 0%, 80%)",
  },
};

export default theme;


